/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState, useContext } from "react";
import { Navbar, Offcanvas } from "react-bootstrap";
import { Link } from "react-router-dom";
import { BsArrowRight, BsCalendarCheckFill, BsPieChartFill } from "react-icons/bs";
import { checkGroupsUser, getlocalStorage } from "../function/functionALL";
import Axios from "axios";
import LoadingTable from "../components/LoadingTable";
import { YearContext } from "../components/usecontext/YearContext";
import Logo from "../img/Logo.png";
import LogoPerson from "../img/logoperson.png";
import LogoSW from "../img/LogoSW.png";
import Swal from "sweetalert2";

const ManuTestRoud = ({ expand, toggleMenu }) => {
  const [loading, setLoading] = useState(true);
  const { Token, DataToken_ } = getlocalStorage();
  const role = checkGroupsUser(DataToken_.groups);
  const role_openRole = role?.openRole;
  const [units, setUnits] = useState([]);
  const [Round_year, setRound_year] = useState([]);
  const { yearcurrent, setyearcurrent } = useContext(YearContext);

  useEffect(() => {
    GetRound_year();
  }, []);

  useEffect(() => {
    if (yearcurrent !== null) {
      setLoading(true);
      GetUnit();
    }
  }, [yearcurrent]);

  const GetRound_year = async () => {
    try {
      setLoading(true);
      const response = await Axios.get(process.env.REACT_APP_API_Distinct, {
        headers: { Authorization: "Token " + Token },
      });
      const res = response.data;
      const uniqueBudgetYears = [...new Set(res.map((item) => item.budget_year))];
      const sortedBudgetYears = uniqueBudgetYears.sort((a, b) => b - a);
      const budgetYearsObject = sortedBudgetYears.map((year) => ({ budget_year: year }));
      setRound_year(budgetYearsObject);
      setLoading(false);
    } catch (error) {
      if (error.response && error.response.status === 401) {
        localStorage.removeItem("Token_");
        localStorage.removeItem("Token");
      }
      console.error(error);
      Swal.fire({ icon: "error" });
      setLoading(false);
    }
  };

  const combinedUnitsMap = (res) => {
    const result = res.reduce((map, item) => {
      if (!map.has(item.unit)) {
        map.set(item.unit, {
          budget_year: item.budget_year,
          unit: item.unit,
          unit_name: item.unit_name,
          all_round: [],
        });
      }
      map.get(item.unit).all_round.push({
        round: item.round,
        id: item.id,
        date: item.date,
      });
      return map;
    }, new Map());

    for (const unit of result.values()) {
      unit.all_round.sort((a, b) => a.id - b.id);
    }
    return result;
  };

  const GetUnit = async () => {
    try {
      let res = [];
      let url =
        process.env.REACT_APP_API_TESTROUND + `?budget_year=${yearcurrent}&limit=200`;
      while (url) {
        const response = await Axios.get(url, {
          headers: { Authorization: "Token " + Token },
        });
        res = res.concat(response.data.results);
        url = response.data.next;
      }

      const combinedUnitsMap_1 = combinedUnitsMap(res);
      const combinedUnits = Array.from(combinedUnitsMap_1.values()).sort((a, b) =>
        a.unit_name.localeCompare(b.unit_name)
      );

      setUnits(combinedUnits);
      setLoading(false);
    } catch (error) {
      if (error.response && error.response.status === 401) {
        localStorage.removeItem("Token_");
        localStorage.removeItem("Token");
      }
      console.error(error);
      Swal.fire({ icon: "error" });
      setLoading(false);
    }
  };

  return (
    <Navbar.Offcanvas
      id={`offcanvasNavbar-expand-${expand}`}
      aria-labelledby={`offcanvasNavbarLabel-expand-${expand}`}
      placement="end"
    >
      <Offcanvas.Header closeButton>
        <Offcanvas.Title></Offcanvas.Title>
      </Offcanvas.Header>
      <Offcanvas.Body>
        <div className=" ">
          <div className="logo  w-100 align-items-center   p-2 pt-3 col-12 ">
            <div className="col-12 d-flex justify-content-center">
              <img
                src={Logo}
                className="logo-upscale p-auto mx-2 w-auto m-0 figure-img img-fluid rounded"
                alt="logo"
                width="100px"
                height="100px"
              />
              <img
                src={LogoPerson}
                className="logo-upscale p-auto  mx-2 w-auto m-0 figure-img img-fluid rounded"
                alt="logo"
                width="100px"
                height="100px"
              />
              <img
                src={LogoSW}
                className="logo-upscale p-auto  mx-2 w-auto m-0 figure-img img-fluid rounded"
                alt="logo"
                width="100px"
                height="100px"
              />
            </div>
            <div className="d-flex justify-content-center">
              <h5 className="card-title fw-bold" style={{ fontSize: "14px" }}>
                ระบบทดสอบสมรรถภาพทางกายกำลังพลทหารอากาศ
              </h5>
            </div>
          </div>

          <div className="card-body m-2" style={{ background: "rgb( 123, 151, 225,0.6)" }}>
            <h5 className="card-title fw-bold" style={{ fontSize: "16px" }}>
              <BsCalendarCheckFill className="me-2" /> วงรอบการทดสอบ
            </h5>
            <div className="post-item clearfix fw-bold" style={{ fontSize: "14px" }}>
              {loading ? (
                <LoadingTable />
              ) : (
                <div>
                  <div>
                    {Round_year.map((item, index) => (
                      <Link
                        key={index}
                        style={{ display: "block", marginBottom: "8px" }}
                        to={`/PageResultGraph`}
                        onClick={() => {
                          setyearcurrent(item.budget_year);
                        }}
                      >
                        {item.budget_year === yearcurrent ? (
                          <>
                            <BsArrowRight />
                            {item.budget_year + 543}
                          </>
                        ) : (
                          <>{item.budget_year + 543}</>
                        )}
                      </Link>
                    ))}
                  </div>
                </div>
              )}
            </div>
          </div>

          <div className="card">
            <div
              className="card-body pb-0 m-2"
              style={{ background: "rgb( 123, 151, 225,0.6)", fontSize: "14px" }}
            >
              <h6 className="card-title fw-bold" style={{ fontSize: "16px" }}>
                <BsPieChartFill className="me-2" />
                ผลการวิเคราะห์{" "}
              </h6>
              {role_openRole?.RTAFPersonAdmin ? (
                <p className="fw-bold">
                  <Link to={`/PageResultGraph`} onClick={() => toggleMenu()}>
                    รวมทุกหน่วย
                  </Link>
                </p>
              ) : (
                ""
              )}
              <div className="mt-2">
                {loading ? (
                  <LoadingTable />
                ) : yearcurrent ? (
                  <div>
                    {units.length === 0 ? (
                      <p>ไม่มีการทดสอบในวงรอบ</p>
                    ) : (
                      units.map((unit, index) => (
                        <p key={`${unit.id}-${index}`} className="fw-bold">
                          <Link
                            to={`/PageResultGraphUnits`}
                            state={{
                              unitid: unit.unit,
                              unitname: unit.unit_name,
                              all_round: unit.all_round,
                            }}
                            onClick={() => toggleMenu()}
                          >
                            {unit.unit_name}
                          </Link>
                        </p>
                      ))
                    )}
                  </div>
                ) : (
                  <p>กรุณาเลือกวงรอบการทดสอบ</p>
                )}
              </div>
            </div>
          </div>
        </div>
      </Offcanvas.Body>
    </Navbar.Offcanvas>
  );
};

export default ManuTestRoud;

